export const GALLERY_EDITOR_GRID_GAP_PX = 6;
export const GALLERY_EDITOR_ITEM_FADE_DURATION_S = 0.18;
export const GALLERY_EDITOR_PREVIEW_FADE_DURATION_S = 0.16;
export const GALLERY_EDITOR_MEDIA_FADE_DURATION_S = 0.2;
export const GALLERY_EDITOR_DELETE_BUTTON_Z_INDEX = 3;
